import backend from "../utils/backend";
import {
  SET_UNAUTHED_SUBSCRIPTIONS,
  SET_UNAUTHED_SUBSCRIPTIONS_SUCCESS,
  SET_UNAUTHED_SUBSCRIPTIONS_ERROR,
  GET_USER_DATA,
  GET_USER_DATA_SUCCESS,
  GET_USER_DATA_ERROR,
  UPDATE_USER_SUBSCRIPTIONS,
  UPDATE_USER_SUBSCRIPTIONS_SUCCESS,
  UPDATE_USER_SUBSCRIPTIONS_ERROR,
} from "../constants/actionTypes";

export const getUserData = () => {
  return (dispatch) => {
    dispatch({
      type: GET_USER_DATA,
    });

    return backend.request({
      method: "GET",
      url: "/readers/me/",
    })
      .then((response) => {
        dispatch({
          type: GET_USER_DATA_SUCCESS,
          payload: response.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_USER_DATA_ERROR,
          payload: err,
        });
      });
  };
};

export const updateUserSubscriptions = (subscriptions, subscription) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_USER_SUBSCRIPTIONS,
    });

    return backend.request({
      method: "PATCH",
      url: "/readers/update/",
      data: {
        subscriptions: subscriptions.map((s) => s.id).concat(subscription.id),
      },
    })
      .then(() => {
        dispatch({
          type: UPDATE_USER_SUBSCRIPTIONS_SUCCESS,
          payload: subscriptions.concat(subscription),
        });
      })
      .catch((err) => {
        dispatch({
          type: UPDATE_USER_SUBSCRIPTIONS_ERROR,
          payload: err,
        });
      });
  };
};

export const updateUnAuthedSubscriptions = (email, lists) => {
  return (dispatch) => {
    dispatch({
      type: SET_UNAUTHED_SUBSCRIPTIONS,
    });

    return backend.request({
      method: "POST",
      url: "/readers/unauth-sub/",
      data: {
        email,
        lists,
      },
    })
      .then(() => {
        dispatch({
          type: SET_UNAUTHED_SUBSCRIPTIONS_SUCCESS,
        });
      })
      .catch((err) => {
        dispatch({
          type: SET_UNAUTHED_SUBSCRIPTIONS_ERROR,
          payload: err,
        });
      });
  };
};
